module.exports = __webpack_public_path__ + "static/media/licensing.0a867795.svg";